import axios from 'axios'

//API_URL needs to be whatever the server route is
const API_URL = 'https://elana-api.herokuapp.com/api/newsletter/'

// Add email to newsletter recipient list
const addEmailRecipient = async (userData) => {
  const response = await axios.post(API_URL, userData)

  if (response.data) {
    console.log(response.data)
  }

  return response.data
}

// Retrieve entire list of newsletter email recipients
const getAllEmailRecipients = async () => {
  const response = await axios.get(API_URL)

  if (response.data) {
    console.log(response.data)
  }

  return response.data
}

const emailCollectionService = {
  addEmailRecipient,
  getAllEmailRecipients
}

export default emailCollectionService